import { Injectable, AccessToken } from "@clairejs/core";
import { AbstractStorage } from "../system/AbstractStorage";
import { AbstractTokenManager } from "./AbstractTokenManager";

@Injectable()
export class DefaultTokenManager extends AbstractTokenManager {
    private accessToken?: AccessToken = null!;

    constructor(readonly storage: AbstractStorage, readonly storageKey: string = "ACCESS_TOKEN") {
        super();
    }

    async getAccessToken(): Promise<AccessToken | undefined> {
        if (this.accessToken === null) {
            this.accessToken = await this.storage.getItem(this.storageKey);
        }
        return this.accessToken;
    }

    async setAccessToken(token?: AccessToken): Promise<void> {
        if (token) {
            await this.storage.setItem(this.storageKey, token);
        } else {
            await this.storage.deleteItem(this.storageKey);
        }
        this.accessToken = token;
    }
}
